import { PATH } from 'constants/path';
import { getUrlParam, isKlarityHost, isOpPortal } from './common';
import { getHasOnceSuccessLogin, setAdminToken, setScheduleToken, setUserToken } from './localstore';
import { setCookieLogoutTime, setCookieProviderToken, setCookieProviderTokenSetTime } from './shareAccount';
//http://localhost:8085/credentialing/landing?autoRedirect=true
export const redirecToLogout = () => {
    if (window) {
        const { origin } = window.location;
        const autoRedirect = getUrlParam('autoRedirect');
        const redirectPath = window.location.pathname;
        let url = `${origin}${PATH.PPA_LOGIN}`;
        if (isOpPortal()) {
            url = `${origin}/${PATH.LOGIN}`;
        } else if (isKlarityHost()) {
            url = `${origin}${PATH.PPA_LOGIN}`;
        } else if (getHasOnceSuccessLogin()) {
            url = `${origin}/${PATH.PROVIDER_LOGIN}`;
        } else {
            url = `${origin}${PATH.SIGNUP}`;
        }
        if (autoRedirect) {
            url = `${url}?redirect=${encodeURIComponent(redirectPath)}`;
        }
        window.location.href = url;
    }
};

export const redirecToPPALogout = () => {
    if (window) {
        const { origin } = window.location;
        setUserToken('');
        setScheduleToken('');
        setAdminToken('');
        setCookieLogoutTime(new Date().getTime());
        setCookieProviderToken('');
        setCookieProviderTokenSetTime(0);
        window.location.href = `${origin}${PATH.PPA_LOGIN}`;
    }
};
